/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.query.understanding.mkpl.autocomp.rpc.MarketplaceAutocompletePublicRpc
 */

export const autocompleteRpc = {
  serviceName: 'com.hubspot.query.understanding.mkpl.autocomp.rpc.MarketplaceAutocompletePublicRpc',
  rpcName: 'autocomplete',
  auth: 'external',
  fingerprint: 'FkqeuHqs_QWWyBFWfVmzC-S0OyEDABBF',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};